module.exports = __webpack_public_path__ + "media/toolkits/HVAC-phones-overlay-f5a4ba04.png";